import React from "react";
import EmailLinkTabPage from "../../Components/email-link/EmailLinkTabPage";

// Customer Email and Dealer Email are now one page (see EmailLinkTabPage),
// switched from the folder sidebar on the left. This route is the canonical
// entry point; /dealer-email redirects here with ?side=dealer.
const CustomerEmailPage: React.FC = () => <EmailLinkTabPage />;

export default CustomerEmailPage;
